import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComposableCardComponent } from './card/card.component';

@NgModule({
  imports: [CommonModule, ComposableCardComponent],
  exports: [ComposableCardComponent],
})
export class ComposablesModule {}
